import { render, staticRenderFns } from "./popup-board.vue?vue&type=template&id=7257837e&"
import script from "./popup-board.vue?vue&type=script&lang=js&"
export * from "./popup-board.vue?vue&type=script&lang=js&"
import style0 from "./popup-board.vue?vue&type=style&index=0&id=7257837e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports